module.exports = "<div class=\"page\">\n\t<div class=\"left\">\n\t\t<h1><span class=\"underline\">Hello!<span class=\"color-contrast\"></span></span></h1>\n\t\t<p>Attaboy is a creative review and delivery platform developed by <a href=\"https://bannerboy.com\" target=\"_blank\" class=\"underline\">Bannerboy<span class=\"color-contrast\"></span></a>, a digital production company.</p>\n\t</div>\n\t<div class=\"right\">\n\t\t<img src=\"./assets/img/home-illustration.png\" alt=\"\">\n\t</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/home/home.component.html
// module id = ../../../../../src/app/home/home.component.html
// module chunks = main